(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easy-customer-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-easy-customer-center]');
    if (!root || root.dataset.mounted === 'true') return;
    root.dataset.mounted = 'true';

    const clientId = root.dataset.clientId;
    const shopDomain = root.dataset.shopDomain;
    const callbackUrl = root.dataset.callbackUrl;
    const copy = JSON.parse(root.querySelector('[data-easy-customer-copy]').textContent);
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    const orderCopy = english ? {
      all:'All orders', pending:'Awaiting shipment', fulfilled:'Shipped', products:'Products', details:'View products, specifications and delivery', adjustment:'Tax / total adjustment', unknown:'Status unavailable', cancelled:'Cancelled',
      PAID:'Paid', PENDING:'Payment pending', AUTHORIZED:'Payment authorized', PARTIALLY_PAID:'Partially paid', PARTIALLY_REFUNDED:'Partially refunded', REFUNDED:'Refunded', VOIDED:'Voided', EXPIRED:'Expired'
    } : {
      all:'全部订单', pending:'待发货', fulfilled:'已发货', products:'商品', details:'查看商品、规格和配送信息', adjustment:'税费及金额调整', unknown:'状态暂不可用', cancelled:'已取消',
      PAID:'已付款', PENDING:'待付款', AUTHORIZED:'付款已授权', PARTIALLY_PAID:'部分付款', PARTIALLY_REFUNDED:'部分退款', REFUNDED:'已退款', VOIDED:'付款已作废', EXPIRED:'付款已过期'
    };
    Object.assign(copy, document.documentElement.lang.toLowerCase().startsWith('en') ? {
      invoice: 'Create / download invoice',
      invoice_note: 'Return after payment to create or download your invoice again. All products in this order are combined into one PDF, including multiple pages.',
      invoice_company: 'Company name (required)', invoice_email: 'Invoice email (optional)',
      invoice_generate: 'Generate and download invoice', invoice_working: 'Verifying your order and generating the invoice…',
      invoice_download: 'Download PDF invoice', invoice_ready: 'Your invoice is ready. If the download did not start, use the button below.',
      invoice_emailed: 'Your invoice is ready and has been emailed. You can also download it below.',
      invoice_email_failed: 'Your invoice is ready to download, but the email could not be sent. Please try again later.',
      invoice_error: 'Unable to generate the invoice. Please try again later or contact 7572277697.',
      invoice_download: 'Download invoice', invoice_send: 'Email me the invoice', invoice_email_required: 'Please enter a valid email address first.',
      invoice_login: 'Your session expired. Please sign in again to generate an invoice.',
      invoice_unpaid: 'Invoices are available after payment, except for cancelled or fully refunded orders.'
    } : {
      invoice: '开具/下载发票',
      invoice_note: '付款后可随时回来补开或重新下载。同一订单的所有产品汇总为一个 PDF，多页自动合并。',
      invoice_company: '公司名称（发票抬头，必填）', invoice_email: '接收发票的邮箱（选填）',
      invoice_generate: '生成并下载发票', invoice_working: '正在核对订单并生成发票，请稍候…',
      invoice_download: '下载 PDF 发票', invoice_ready: '发票已生成。如果未自动下载，请点击下方下载按钮。',
      invoice_emailed: '发票已生成并发送到您填写的邮箱，也可点击下方下载。',
      invoice_email_failed: '发票已生成，可立即下载；邮件暂未发送成功，请稍后重试。',
      invoice_error: '暂时无法生成发票，请稍后重试；如需帮助，请联系 7572277697。',
      invoice_download: '下载发票', invoice_send: '发到我邮箱', invoice_email_required: '请先填写正确的接收发票邮箱。',
      invoice_login: '登录已过期，请重新登录后开票。',
      invoice_unpaid: '订单付款完成后可开票；已取消或已全额退款的订单暂不支持。'
    });
    copy.reorder=english?'Buy again':'再次购买';
    if (!english) { copy.order='订单'; copy.job='商品项目'; copy.job_status='发货状态'; copy.status_fulfilled='已发货'; copy.status_received='待发货'; copy.status_in_progress='处理中'; }
    const message = root.querySelector('[data-easy-customer-message]');
    const signin = root.querySelector('[data-easy-customer-signin]');
    const app = root.querySelector('[data-easy-customer-app]');
    const ordersNode = root.querySelector('[data-easy-orders]');
    const emptyNode = root.querySelector('[data-easy-orders-empty]');
    const loginButton = root.querySelector('[data-easy-customer-login]');
    const logoutButton = root.querySelector('[data-easy-customer-logout]');
    const filterInput = root.querySelector('[data-easy-order-filter]');
    const searchInput = root.querySelector('[data-easy-order-search]');
    const tokenKey = 'easy_customer_access_token';
    const refreshKey = 'easy_customer_refresh_token';
    const expiryKey = 'easy_customer_token_expiry';
    const idTokenKey = 'easy_customer_id_token';
    const verifierKey = 'easy_customer_code_verifier';
    const stateKey = 'easy_customer_oauth_state';
    let authConfig;
    let apiConfig;
    let orders = [];
    const retryButton = root.querySelector('[data-easy-customer-retry]');
    const reloginButton = root.querySelector('[data-easy-customer-relogin]');
    let initializing = false;
    const timedFetch = async (url, options = {}) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 30000);
      try { return await fetch(url, { ...options, signal: controller.signal }); }
      finally { clearTimeout(timer); }
    };

    const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[character]);
    const randomValue = (length = 64) => {
      const bytes = new Uint8Array(length);
      crypto.getRandomValues(bytes);
      return Array.from(bytes, (byte) => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'[byte % 66]).join('');
    };
    const base64Url = (bytes) => btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const challengeFor = async (verifier) => base64Url(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))));
    const discover = async () => {
      if (!authConfig) authConfig = await timedFetch(`https://${shopDomain}/.well-known/openid-configuration`).then((response) => { if (!response.ok) throw new Error(copy.error); return response.json(); });
      if (!apiConfig) apiConfig = await timedFetch(`https://${shopDomain}/.well-known/customer-account-api`).then((response) => { if (!response.ok) throw new Error(copy.error); return response.json(); });
    };
    const saveTokens = (data) => {
      if(window.EasyCustomerSession){window.EasyCustomerSession.save(data);window.dispatchEvent(new Event('easy:auth-changed'));return;}
      sessionStorage.setItem(tokenKey, data.access_token || '');
      if (data.refresh_token) sessionStorage.setItem(refreshKey, data.refresh_token);
      if (data.id_token) sessionStorage.setItem(idTokenKey, data.id_token);
      sessionStorage.setItem(expiryKey, String(Date.now() + Math.max(30, Number(data.expires_in || 3600) - 60) * 1000));
      window.dispatchEvent(new Event('easy:auth-changed'));
    };
    const clearTokens = () => {
      window.EasyCustomerSession?.clear();
      [tokenKey, refreshKey, expiryKey, idTokenKey, verifierKey, stateKey].forEach((key) => sessionStorage.removeItem(key));
      window.dispatchEvent(new Event('easy:auth-changed'));
    };
    const beginLogin = async () => {
      await discover();
      const verifier = randomValue(72);
      const state = randomValue(36);
      sessionStorage.setItem(verifierKey, verifier);
      sessionStorage.setItem(stateKey, state);
      const url = new URL(authConfig.authorization_endpoint);
      url.searchParams.set('scope', 'openid email customer-account-api:full');
      url.searchParams.set('client_id', clientId);
      url.searchParams.set('response_type', 'code');
      url.searchParams.set('redirect_uri', callbackUrl);
      url.searchParams.set('state', state);
      url.searchParams.set('nonce', randomValue(36));
      url.searchParams.set('code_challenge', await challengeFor(verifier));
      url.searchParams.set('code_challenge_method', 'S256');
      window.location.assign(url.toString());
    };
    const exchangeCode = async (code, returnedState) => {
      const expectedState = sessionStorage.getItem(stateKey);
      const verifier = sessionStorage.getItem(verifierKey);
      if (!expectedState || expectedState !== returnedState || !verifier) throw new Error(copy.error);
      await discover();
      const body = new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: clientId,
        redirect_uri: callbackUrl,
        code,
        code_verifier: verifier
      });
      const response = await timedFetch(authConfig.token_endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body
      });
      if (!response.ok) throw new Error(copy.error);
      saveTokens(await response.json());
      sessionStorage.removeItem(verifierKey);
      sessionStorage.removeItem(stateKey);
      history.replaceState({}, document.title, callbackUrl);
    };
    const refreshAccessToken = async () => Boolean(await window.EasyCustomerSession?.refresh());
    const accessToken = async () => await window.EasyCustomerSession?.token() || '';
    const orderQuery = `query EasyCustomerOrders($first: Int!, $after: String) {
      customer {
        id
        displayName
        emailAddress { emailAddress }
        orders(first: $first, after: $after, reverse: true) {
          nodes {
            id
            name
            processedAt
            fulfillmentStatus
            statusPageUrl
            financialStatus
            confirmationNumber
            cancelledAt
            totalPrice { amount currencyCode }
            discountApplications(first: 10) {
              nodes { ... on ManualDiscountApplication { title value { ... on MoneyV2 { amount currencyCode } } } }
            }
            lineItems(first: 50) {
              nodes {
                id
                name
                presentmentTitle
                quantity
                currentTotalPrice { amount currencyCode }
                image { url altText width height }
                customAttributes { key value }
              }
            }
          }
          pageInfo { hasNextPage endCursor }
        }
      }
    }`;
    const customerOrders = async () => {
      await discover();
      let token = await accessToken();
      if (!token) return null;
      const allOrders = [];
      const seenCursors = new Set();
      let customerProfile = null;
      let after = null;
      let hasNextPage = true;
      while (hasNextPage) {
        const request = () => timedFetch(apiConfig.graphql_api, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: token },
          body: JSON.stringify({ query: orderQuery, variables: { first: 50, after } })
        });
        let response = await request();
        if (response.status === 401 && await refreshAccessToken()) {
          token = sessionStorage.getItem(tokenKey);
          response = await request();
        }
        if (response.status === 401) { window.EasyCustomerSession?.reject(); return null; }
        if (!response.ok) throw new Error(copy.error);
        const result = await response.json();
        if (result.errors?.length) throw new Error(result.errors[0].message || copy.error);
        const customer = result.data.customer;
        if (!customer) return null;
        if (!customerProfile) customerProfile = customer;
        allOrders.push(...(customer.orders?.nodes || []));
        const pageInfo = customer.orders?.pageInfo;
        const nextCursor = pageInfo?.hasNextPage ? pageInfo.endCursor : null;
        hasNextPage = Boolean(nextCursor && !seenCursors.has(nextCursor));
        if (nextCursor) seenCursors.add(nextCursor);
        after = nextCursor;
      }
      return { ...customerProfile, orders: { nodes: allOrders } };
    };
    const statusText = (status) => ({
      UNFULFILLED: copy.status_received,
      OPEN: copy.status_received,
      IN_PROGRESS: copy.status_in_progress,
      PENDING_FULFILLMENT: copy.status_in_progress,
      PARTIALLY_FULFILLED: copy.status_partially_fulfilled,
      FULFILLED: copy.status_fulfilled,
      ON_HOLD: copy.status_on_hold,
      SCHEDULED: copy.status_scheduled
    })[status] || copy.status_unavailable;
    const money = (moneyValue) => {
      const amount = Number(moneyValue?.amount || 0);
      const currency = moneyValue?.currencyCode || 'USD';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
    };
    const dateTime = (value) => new Intl.DateTimeFormat(english ? 'en-US' : 'zh-CN', {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'
    }).format(new Date(value));
    const publicAttributes = (line) => (line.customAttributes || []).filter((attribute) => {
      const key = String(attribute.key || '').toLowerCase();
      return attribute.value && !key.startsWith('_') && !['supplier', 'formula', 'cost', 'shipping module', 'product id', 'variant id'].some((term) => key.includes(term));
    });
    const uploadedArtwork = (line) => (line.customAttributes || []).flatMap(attribute => {
      const key = String(attribute.key || '').trim();
      if (!key || key.startsWith('_') || !/^(?:Upload(?:\s+File)?|上传(?:文件|图片)?|文件|版本\s*\d+|画面\s*\d+)/i.test(key)) return [];
      try {
        const url = new URL(String(attribute.value || '').trim());
        if (url.origin !== 'https://shopify-banner-calculator.jiemg1989.workers.dev' || !url.pathname.startsWith('/upload/file/') || !url.searchParams.get('token')) return [];
        const path = decodeURIComponent(url.pathname);
        return [{url:url.href,image:/\.(?:jpe?g|png)$/i.test(path)}];
      } catch (_) { return []; }
    });
    const artworkHtml = (line) => {
      const files = uploadedArtwork(line);
      if (!files.length) return '';
      return `<section class="easy-customer-artwork" aria-label="客户上传图片"><p><strong>客户上传图片</strong> · 已上传${files.length}个文件${files.length > 2 ? '，显示前两张' : ''}</p><div class="easy-customer-artwork__previews">${files.slice(0,2).map((file,index) => `<div class="easy-customer-artwork__preview"><strong>图片${index + 1}</strong>${file.image ? `<img data-easy-artwork-preview src="${escapeHtml(file.url)}" alt="客户上传图片${index + 1}" loading="lazy" width="120" height="120"><p data-easy-artwork-error hidden>图片暂无法加载，请查看原文件。</p>` : '<p>此格式暂不支持缩略图，请查看原文件。</p>'}<a href="${escapeHtml(file.url)}" target="_blank" rel="noopener noreferrer">查看／下载原文件</a></div>`).join('')}</div>${files.length > 2 ? `<div class="easy-customer-artwork__links">${files.slice(2).map((file,index) => `<a href="${escapeHtml(file.url)}" target="_blank" rel="noopener noreferrer">文件${index + 3}：查看／下载</a>`).join('')}</div>` : ''}</section>`;
    };
    const productHandle = (line) => (line.customAttributes || []).find((attribute) => ['product handle', '_product handle'].includes(String(attribute.key || '').toLowerCase()))?.value || '';
    const adjustmentLine = (line) => /^(Order Total Adjustment|税费及金额调整)$/i.test(String(line.name || line.presentmentTitle || '').trim());
    const productionQuantity = (line) => {
      const attribute=(line.customAttributes || []).find(item=>/^(quantity|数量)$/i.test(String(item.key || '').trim()));
      const value=attribute && Number(attribute.value);
      return Number.isInteger(value) && value>0 ? value : line.quantity;
    };
    const displayAttribute = (attribute) => {
      if (window.EasyChinese) return {key:window.EasyChinese.label(attribute.key),value:window.EasyChinese.value(attribute.value,attribute.key)};
      if (english) return attribute;
      const labels = {'size':'尺寸','width':'宽度','height':'高度','quantity':'数量','orientation':'方向','paper':'纸张','color':'颜色','material':'材质','production time':'生产时间','delivery method':'配送方式','shipping address':'邮寄地址','customer-entered shipping address':'客户填写的邮寄地址','customer name':'客户姓名','customer phone':'电话','note':'备注','notes':'备注','shipping':'运费'};
      const key=labels[String(attribute.key || '').toLowerCase()] || attribute.key;
      const values={'Shipping':'邮寄','Pickup':'自取','Vertical':'竖版','Horizontal':'横版','regular':'常规','1-8 Business Days':'1-8个工作日'};
      return {key,value:values[attribute.value] || attribute.value};
    };
      const dealerOrderSummary = order => {
        const discounts = order.discountApplications?.nodes || [];
        const dealer = discounts.find(item => item.title === '经销商专享八折' && item.value?.amount);
        if (!dealer) return '';
        const discount = Number(dealer.value.amount);
        const paid = Number(order.totalPrice?.amount);
        if (!Number.isFinite(discount) || !Number.isFinite(paid)) return '';
        const original = { ...order.totalPrice, amount: (paid + discount).toFixed(2) };
        return `<span>订单原价：${escapeHtml(money(original))}<br>经销商专享八折：优惠 ${escapeHtml(money(dealer.value))}<br>折后订单金额：</span>`;
      };
      const jobHtml = (order, line, index) => {
      if (adjustmentLine(line)) return `<div class="easy-customer-order__fee"><span>${escapeHtml(orderCopy.adjustment)}</span><strong>${escapeHtml(money(line.currentTotalPrice))}</strong></div>`;
      const handle = productHandle(line);
      const image = line.image?.url || '';
      const imageHtml = image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(line.image?.altText || line.name)}" loading="lazy">` : '<span>E</span>';
      const attributes = publicAttributes(line).filter(attribute=>!/^(quantity|数量)$/i.test(String(attribute.key || '').trim())).map(displayAttribute).map((attribute) => `<div><dt>${escapeHtml(attribute.key)}:</dt> <dd>${escapeHtml(attribute.value)}</dd></div>`).join('');
      const reorderUrl = handle ? `/products/${encodeURIComponent(handle)}` : `/search?q=${encodeURIComponent(line.presentmentTitle || line.name || '')}`;
      const reorderAttributes = publicAttributes(line).filter(attribute=>/^(width|height|quantity|size|paper|color|orientation|material|print sides|cutting|pole pocket|hem|grommet|selected specifications|variant|宽度|高度|数量|尺寸|纸张|颜色|方向|材质|印刷面数|切割方式|杆袋|包边|扣眼|已选规格|规格)$/i.test(String(attribute.key || '').trim())).map(displayAttribute);
      if (!reorderAttributes.some(attribute=>/^(quantity|数量)$/i.test(attribute.key))) reorderAttributes.push({key:'Quantity',value:String(productionQuantity(line))});
      return `<article class="easy-customer-job">
        <div class="easy-customer-job__image" data-product-handle="${escapeHtml(handle)}" data-product-title="${escapeHtml(line.presentmentTitle || line.name || '')}">${imageHtml}</div>
        <div>
          <p class="easy-customer-job__id">${escapeHtml(copy.job)} ${escapeHtml(order.name.replace('#', ''))}-${index + 1}</p>
          <h3>${escapeHtml(window.EasyChinese.text(line.presentmentTitle || line.name))}</h3>
          <dl class="easy-customer-job__attributes"><div><dt>${escapeHtml(copy.quantity)}:</dt> <dd>${escapeHtml(productionQuantity(line))}</dd></div>${attributes}</dl>
          ${artworkHtml(line)}
        </div>
        <div class="easy-customer-job__status-cell">
          <p class="easy-customer-job__id">${escapeHtml(copy.job_status)}</p>
          <span class="easy-customer-job__status" data-status="${escapeHtml(order.fulfillmentStatus)}">${escapeHtml(statusText(order.fulfillmentStatus))}</span>
        </div>
        <div class="easy-customer-job__actions">
          <div class="easy-customer-job__price">${escapeHtml(money(line.currentTotalPrice))}</div>
          <a class="easy-customer-job__reorder" href="${escapeHtml(reorderUrl)}${handle?'?reorder=1':''}" ${handle?`data-easy-reorder="${escapeHtml(JSON.stringify({handle,attributes:reorderAttributes}))}"`:''}>${escapeHtml(handle?copy.reorder:(english?'View product':'查看商品'))}</a>
        </div>
      </article>`;
    };
    const orderHtml = (order) => `<section class="easy-customer-order" data-cancelled="${!!order.cancelledAt}" data-status="${escapeHtml(order.fulfillmentStatus)}" data-search="${escapeHtml(`${order.name} ${order.confirmationNumber || ''} ${order.processedAt} ${(order.lineItems?.nodes || []).map((line) => `${line.name} ${line.presentmentTitle || ''} ${(line.customAttributes || []).map((attribute) => `${attribute.key} ${attribute.value}`).join(' ')}`).join(' ')}`.toLowerCase())}">
      <header class="easy-customer-order__header">
        <div><span class="easy-customer-order__number">${escapeHtml(copy.order)} ${order.confirmationNumber ? '#' + escapeHtml(order.confirmationNumber) + ' (' + escapeHtml(order.name) + ')' : escapeHtml(order.name)}</span><span class="easy-customer-order__date">${escapeHtml(dateTime(order.processedAt))}</span></div>
        <div class="easy-customer-order__summary">${dealerOrderSummary(order)}<span class="easy-customer-order__total">${escapeHtml(money(order.totalPrice))}</span>${order.statusPageUrl ? `<a class="easy-customer-order__detail" href="${escapeHtml(order.statusPageUrl)}">${escapeHtml(copy.order_detail)}</a>` : ''}</div>
      </header>
      <div class="easy-customer-order__quick">
        <span class="easy-customer-order__badge">${escapeHtml(order.cancelledAt ? orderCopy.cancelled : orderCopy[order.financialStatus] || orderCopy.unknown)}</span>
        <span>${escapeHtml(statusText(order.fulfillmentStatus))}</span>
        <p class="easy-customer-order__products">${escapeHtml(orderCopy.products)}：${escapeHtml((order.lineItems?.nodes || []).filter(line=>!adjustmentLine(line)).map(line=>window.EasyChinese.text(line.presentmentTitle || line.name)).join('、'))}</p>
      </div>
      ${invoiceHtml(order)}
      <details class="easy-customer-order__expand"><summary>${escapeHtml(orderCopy.details)}</summary>
      ${(order.lineItems?.nodes || []).map((line, index) => jobHtml(order, line, index)).join('')}
      </details>
    </section>`;
    const invoiceHtml = (order) => `<details class="easy-customer-invoice">
      <summary>${escapeHtml(copy.invoice)}</summary>
      ${!order.cancelledAt && ['PAID', 'PARTIALLY_REFUNDED'].includes(order.financialStatus) ? `<form novalidate data-invoice-order="${escapeHtml(order.id)}">
        <p>${escapeHtml(copy.invoice_note)}</p>
        <label>${escapeHtml(copy.invoice_company)}<input name="company" required maxlength="160" autocomplete="organization"></label>
        <label>${escapeHtml(copy.invoice_email)}<input name="email" type="email" maxlength="254" autocomplete="email"></label>
        <div><button type="submit" data-invoice-action="download" class="easy-customer-center__primary">${escapeHtml(copy.invoice_download)}</button>
        <button type="submit" data-invoice-action="email" class="easy-customer-center__primary">${escapeHtml(copy.invoice_send)}</button></div>
        <p data-invoice-status role="status" aria-live="polite"></p>
        <a data-invoice-download target="_blank" rel="noopener" hidden>${escapeHtml(copy.invoice_download)}</a>
        <button type="button" data-invoice-login hidden>${escapeHtml(copy.sign_in || (english ? 'Sign in again' : '重新登录'))}</button>
      </form>` : `<p>${escapeHtml(copy.invoice_unpaid)}</p>`}
    </details>`;
    const requestInvoice = async (form, action = 'download') => {
      const buttons = [...form.querySelectorAll('[data-invoice-action]')];
      const status = form.querySelector('[data-invoice-status]');
      const download = form.querySelector('[data-invoice-download]');
      const relogin = form.querySelector('[data-invoice-login]');
      if (buttons.some(button => button.disabled)) return;
      if (!form.elements.company.value.trim()) { status.textContent = copy.invoice_company; form.elements.company.focus(); return; }
      const email = action === 'email' ? form.elements.email.value.trim() : '';
      if (action === 'email' && (!email || email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
        status.textContent = copy.invoice_email_required; form.elements.email.focus(); return;
      }
      buttons.forEach(button => { button.disabled = true; });
      status.textContent = copy.invoice_working;
      download.hidden = true;
      relogin.hidden = true;
      try {
        let token = await accessToken();
        if (!token) throw new Error(copy.invoice_login);
        const send = () => timedFetch(root.dataset.invoiceEndpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ orderId: form.dataset.invoiceOrder, company: form.elements.company.value.trim(), email })
        });
        let response = await send();
        if (response.status === 401) { await refreshAccessToken(); token = await accessToken(); if (token) response = await send(); }
        const result = await response.json();
        if (!response.ok) throw new Error(result.code === 'LOGIN_REQUIRED' ? copy.invoice_login : result.code === 'PAYMENT_REQUIRED' ? copy.invoice_unpaid : copy.invoice_error);
        if (action === 'email') {
          status.textContent = result.emailSent ? copy.invoice_emailed : copy.invoice_email_failed;
          return;
        }
        const url = new URL(result.downloadUrl);
        if (url.origin !== new URL(root.dataset.invoiceEndpoint).origin || !url.pathname.startsWith('/invoice/download/')) throw new Error(copy.invoice_error);
        download.href = url.href;
        download.hidden = false;
        status.textContent = copy.invoice_ready;
        download.click();
      } catch (error) {
        status.textContent = [copy.invoice_login, copy.invoice_unpaid].includes(error.message) ? error.message : copy.invoice_error;
        relogin.hidden = error.message !== copy.invoice_login;
      }
      finally { buttons.forEach(button => { button.disabled = false; }); }
    };
    const applyFilters = () => {
      const status = filterInput.value;
      const query = searchInput.value.trim().toLowerCase();
      let visible = 0;
      ordersNode.querySelectorAll('.easy-customer-order').forEach((order) => {
        const matchesStatus = status === 'all' || (order.dataset.cancelled !== 'true' && (order.dataset.status === status || (status === 'UNFULFILLED' && order.dataset.status === 'OPEN')));
        const matchesQuery = !query || order.dataset.search.includes(query);
        order.hidden = !(matchesStatus && matchesQuery);
        if (!order.hidden) visible += 1;
      });
      emptyNode.hidden = visible !== 0;
      root.querySelectorAll('[data-easy-summary-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.easySummaryFilter===status)));
    };
    ordersNode.addEventListener('error', event => {
      const image = event.target;
      if (!image.matches?.('[data-easy-artwork-preview]')) return;
      image.hidden = true;
      const message = image.parentElement.querySelector('[data-easy-artwork-error]');
      if (message) message.hidden = false;
    }, true);
    ordersNode.addEventListener('click', event => {
      const link = event.target.closest('[data-easy-reorder]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      try {
        const saved = JSON.parse(link.dataset.easyReorder);
        sessionStorage.setItem('easy-reorder', JSON.stringify({...saved,created:Date.now()}));
      } catch (_) {
        event.preventDefault();
        window.location.assign(link.href.split('?')[0]);
      }
    });
    const renderOrders = () => {
      const activeOrders=orders.filter(order=>!order.cancelledAt);
      const pending=activeOrders.filter(order=>['UNFULFILLED','OPEN'].includes(order.fulfillmentStatus)).length;
      const fulfilled=activeOrders.filter(order=>order.fulfillmentStatus==='FULFILLED').length;
      root.querySelector('[data-easy-order-overview]').innerHTML=[['all',orderCopy.all,orders.length],['UNFULFILLED',orderCopy.pending,pending],['FULFILLED',orderCopy.fulfilled,fulfilled]].map(([filter,label,count])=>`<button type="button" data-easy-summary-filter="${filter}" aria-pressed="${filter===filterInput.value}"><span>${escapeHtml(label)}</span><strong>${count}</strong></button>`).join('');
      ordersNode.innerHTML = orders.map(orderHtml).join('');
      hydrateProductImages();
      applyFilters();
    };
    const hydrateProductImages = async () => {
      const imageNodes = [...ordersNode.querySelectorAll('.easy-customer-job__image[data-product-handle]')].filter((node) => node.dataset.productHandle && !node.querySelector('img'));
      await Promise.all(imageNodes.map(async (node) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(node.dataset.productHandle)}.js`);
          if (!response.ok) return;
          const product = await response.json();
          const imageUrl = product.featured_image || product.images?.[0];
          if (!imageUrl) return;
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = node.dataset.productTitle;
          image.loading = 'lazy';
          node.replaceChildren(image);
        } catch (error) {
          console.error('Easy Customer Center product image', error);
        }
      }));
    };
    const showSignin = (errorText = '') => {
      message.hidden = true;
      signin.hidden = false;
      app.hidden = true;
      logoutButton.hidden = true;
      if (errorText) signin.querySelector('p').textContent = errorText;
    };
    const showError = (error) => {
      message.hidden = false;
      message.querySelector('.easy-customer-center__spinner').hidden = true;
      message.querySelector('p').textContent = copy.error;
      retryButton.hidden = false;
      reloginButton.hidden = false;
    };
    const logout = async () => {
      await discover();
      const idToken = sessionStorage.getItem(idTokenKey);
      clearTokens();
      const url = new URL(authConfig.end_session_endpoint);
      if (idToken) url.searchParams.set('id_token_hint', idToken);
      url.searchParams.set('post_logout_redirect_uri', callbackUrl);
      window.location.assign(url.toString());
    };
    const init = async () => {
      if (initializing) return;
      initializing = true;
      retryButton.hidden = true;
      reloginButton.hidden = true;
      message.hidden = false;
      message.querySelector('.easy-customer-center__spinner').hidden = false;
      message.querySelector('p').textContent = copy.loading;
      try {
        const params = new URLSearchParams(location.search);
        if (params.get('error')) {
          clearTokens();
          history.replaceState({}, document.title, callbackUrl);
          showSignin();
          return;
        }
        if (params.get('code')) await exchangeCode(params.get('code'), params.get('state'));
        const customer = await customerOrders();
        if (!customer) {
          showSignin();
          return;
        }
        orders = customer.orders?.nodes || [];
        message.hidden = true;
        signin.hidden = true;
        app.hidden = false;
        logoutButton.hidden = false;
        window.EasyLoginStatus?.confirmed();
        renderOrders();
        const email = customer.emailAddress?.emailAddress || '';
        root.querySelector('[data-easy-customer-email]').textContent = email ? (english ? 'Signed in as: ' : '当前登录邮箱：') + email : '';
        ordersNode.querySelectorAll('form[data-invoice-order] input[name="email"]').forEach(input => { if (!input.value) input.value = email; });
      } catch (error) {
        console.error('Easy Customer Center', error);
        showError(error);
      }
      finally { initializing = false; }
    };

    const safeLogin = async () => {
      if (loginButton.disabled) return;
      loginButton.disabled = true;
      try { await beginLogin(); } catch (error) { showError(error); }
      finally { loginButton.disabled = false; }
    };
    loginButton.addEventListener('click', safeLogin);
    reloginButton.addEventListener('click', safeLogin);
    retryButton.addEventListener('click', init);
    logoutButton.addEventListener('click', () => logout().catch(showError));
    root.querySelector('[data-easy-order-clear]').addEventListener('click', () => { filterInput.value = 'all'; searchInput.value = ''; applyFilters(); searchInput.focus(); });
    ordersNode.addEventListener('click', event => { if (event.target.closest('[data-invoice-login]')) safeLogin(); });
    filterInput.addEventListener('change', applyFilters);
    root.querySelector('[data-easy-order-overview]').addEventListener('click',event=>{
      const button=event.target.closest('[data-easy-summary-filter]');
      if(!button)return;
      filterInput.value=button.dataset.easySummaryFilter;
      applyFilters();
    });
    searchInput.addEventListener('input', applyFilters);
    ordersNode.addEventListener('submit', (event) => {
      const form = event.target.closest('form[data-invoice-order]');
      if (!form) return;
      event.preventDefault();
      requestInvoice(form, event.submitter?.dataset.invoiceAction === 'email' ? 'email' : 'download');
    });
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
